import './index.css'

const Training = () => (
  <div>
    <div className="training-container">
      <h1 className="t">Key Offerings</h1>
      <p className="one">Establish training goals</p>
      <p className="one">Assess end-user needs</p>
      <p className="one">Determine your training delivery methods</p>
      <h1 className="t2">Technology-based options include :</h1>
      <p className="one">
        Curated learning platforms that can provide self placed training and
        intractive engagement
      </p>
      <p className="one">
        Virtual agent training that can act as a support agent to facilitate
        questions and provide support on demand
      </p>
    </div>
  </div>
)

export default Training
